import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"

export const useCryptoApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const decryptApi = useCallback(async (data: {
    encrypted: string
  }): Promise<string> => {
    try {
      const result = await axiosAuthInstance.post('/crypto/decrypt', {
        encrypted: data.encrypted
      })

      return result.data.plaintext
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const encryptApi = useCallback(async (data: {
    plaintext: string
  }): Promise<string> => {
    try {
      const result = await axiosAuthInstance.post('/crypto/encrypt', {
        plaintext: data.plaintext
      })

      return result.data.encrypted
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  return {
    decryptApi,
    encryptApi
  }
}


